import React, { useState, useEffect, useCallback } from 'react';

const HALFTIME_MESSAGES = {
    winning: "Keep it up! They're scared of you.",
    losing:  'Time to fight back. You can do this!',
    level:   "All square. Next goal wins the momentum.",
};

export function HalfTimeScreen({ score, onStart }) {
    const [countdown, setCountdown] = useState(5);

    const handleStart = useCallback(() => onStart(), [onStart]);

    useEffect(() => {
        if (countdown <= 0) {
            handleStart();
            return;
        }
        const t = setTimeout(() => setCountdown(c => c - 1), 1000);
        return () => clearTimeout(t);
    }, [countdown, handleStart]);

    const msg = score.player > score.ai
        ? HALFTIME_MESSAGES.winning
        : score.player < score.ai
            ? HALFTIME_MESSAGES.losing
            : HALFTIME_MESSAGES.level;

    return (
        <div className="arcade-overlay-screen">
            <div className="overlay-card">
                <h2 className="overlay-title">Half Time</h2>
                <div className="overlay-score">
                    <div className="overlay-score-block player">
                        <span className="overlay-score-num">{score.player}</span>
                        <span className="overlay-score-label">YOU</span>
                    </div>
                    <span className="overlay-score-dash">—</span>
                    <div className="overlay-score-block ai">
                        <span className="overlay-score-num">{score.ai}</span>
                        <span className="overlay-score-label">AI</span>
                    </div>
                </div>
                <p className="overlay-message">{msg}</p>
                <button className="overlay-btn" onClick={handleStart}>
                    {countdown > 0 ? `2nd Half in ${countdown}…` : 'Starting…'}
                </button>
            </div>
        </div>
    );
}
